/**
 * @fileoverview GET handler for the "/inbox_vision/:app_group_id/get_inbox_vision_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { inboxVisionAppGroupIdGetInboxVisionData } from "./constants";
import type { InboxVisionAppGroupIdGetInboxVisionDataResult } from "./types";

export const getInboxVisionAppGroupIdGetInboxVisionData = reactQueryFetcherAdapter(
  inboxVisionAppGroupIdGetInboxVisionData,
  (signal: AbortSignal, appGroupId: string): Promise<InboxVisionAppGroupIdGetInboxVisionDataResult> => {
    return fetch(`/inbox_vision/${appGroupId}/get_inbox_vision_data`, "GET", {}, { signal });
  }
);
